import trackWindow from './windowTrack';
import loadTheme from './loadTheme';

export default [
  trackWindow,
  loadTheme,
];
